var $mobileMenu = $('#wco-mobile-menu-2');
var mobileMenuToggleClass = 'wco-mobile-menu-open';

$mobileMenu.find( '#wco-mobile-menu-2-dl-menu' ).dlmenu({
    animationClasses : { classin : 'dl-animate-in-2', classout : 'dl-animate-out-2' },
    onLevelClick : function( el, name ) { return true; },
    onLinkClick : function( el, ev ) { return true; },
    backLabel : 'zurück'
});

var toggleMobileMenu2 = function(){
    var isOpen = $mobileMenu.hasClass(mobileMenuToggleClass);
    if (isOpen){
        $mobileMenu.removeClass(mobileMenuToggleClass);
    }
    else{
        $mobileMenu.addClass(mobileMenuToggleClass);
    }
};

// var controller = new slidebars();
// controller.init();
$( '.wco-mobile-menu-2-toggler' ).on( 'click', function ( event ) {
    event.stopPropagation();
    toggleMobileMenu2();
} );

$( 'body' ).on( 'click', '.js-close-any-slidebar', function ( event ) {
    event.stopPropagation();
    toggleMobileMenu2();
});
